import { IconCautionRoundSolid } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

export const ReportedReviewMessage = () => {
  return (
    <MessageWrap>
      <IconCautionRoundSolid size={20} color={'iconQuaternary'} />
      <span className={Typography.BODY_13_MEDIUM}>신고한 리뷰는 더 이상 보이지 않아요.</span>
    </MessageWrap>
  );
};

const MessageWrap = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${vars.color.textQuaternary};
  & > span {
    margin-left: 2px;
  }
`;
